import React from "react";
import moment from "moment";

export interface UIDateTimeIndicatorProps {
  format?: string;
}

UIDateTimeIndicator.defaultProps = {
  format: "YYYY-MM-DD HH:mm:ss",
} as UIDateTimeIndicatorProps;

export default UIDateTimeIndicator;

function UIDateTimeIndicator(props: { format?: string }) {
  const [currentDate, setCurrentDate] = React.useState(new Date());

  React.useEffect(() => {
    const timeout = window.setTimeout(() => {
      setCurrentDate(new Date());
    }, 500);

    return () => {
      window.clearTimeout(timeout);
    };
  });

  return <>{moment(currentDate).format(props.format)}</>;
}
